$(document).ready(function() {
    $('.faq-question').click(function() {
        $(this).next().slideToggle('fast');
        $(this).find('.faq-accordion-plus').toggleClass('faq-accordion-minus');
        $(this).parent().toggleClass('faq-accordion-visible');
    });
});

//toggle main accordion sections on apply form
$(function() {
    $('.accordion-link').on('click', function(event) {
        $(event.target).closest('.accordion-header').find('.accordion-status').toggleClass('closed');
        $(event.target).closest('.accordion-header').siblings().closest('.accordion').toggleClass('closed').slideToggle(500);
    });
});

//set the faq accordion default to be hidden
$('.faq-accordion').hide();

//faq dropdown functionality
$(function() {
    $('.faq-question-text').on('click', function(event) {
      $('.faq-accordion').show();
      var faqWrapper = $(event.target).closest('.faq-wrapper');
      var faqAnswer = faqWrapper.find('.faq-answer-text');

      //toggle the open close of the plus symbol
      $(this).toggleClass('rotate');
  
      // Close all other open FAQ sections and rotate the plus symbol
      $('.faq-answer-text.open').not(faqAnswer).slideUp(250).removeClass('open');
      $('.faq-question-text.rotate').not($(this)).removeClass('rotate');
  
      // Open/close the clicked FAQ section
      faqAnswer.slideToggle(250).toggleClass('open');
    });
  });

$(function() {
    $('.faq-link').on('click', function(event) {
        var questionId = '#faq-' + $(this).attr('faq-question');
        //if class rotate already exists then the target faq section is already open so dont click just scroll
        if (!$(questionId).closest('.faq-question-text').hasClass('rotate')){
            $(questionId).trigger('click');    
        }
            // Smooth scroll to the element
        $('html, body').animate({
            scrollTop: $(questionId).offset().top -200
        }, 'slow');
    });
});